import { axiosInstance } from ".."

const trelloCheckList = async (projectID) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`/internal/pm/listOrders/${projectID}`).then((res) => { 
            if(res.status === 200){
                console.log(res)
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default trelloCheckList;